












































































import mixins from 'vue-typed-mixins';
import { UserAgreement } from '@/utils/UserAgreementUtils';

export default mixins().extend({
  //       checkboxlabel: LanguageObject;
  //   active: boolean;
  props: {
    value: {
      type: Object as () => Partial<UserAgreement>,
    },
  },
});
